// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { DefaultConfig } from '../../settings/config'
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import { ApiUrls } from '../../utility/ApiUrls'

export const displayMenu = createAsyncThunk("appCommonReducers/displayMenu", async (displayMenuBool) => {
  return displayMenuBool
})

let getUserCall = false

const apiCall = async (method, endpoint, requestPayload) => {
  const authAxios = DefaultConfig().authAxios
  if (method === 'get') {
    return await authAxios.get(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'post') {
    return await authAxios.post(endpoint, requestPayload)
      .then((response) => {
        const respData = response.data

        if (respData) {
          if (respData.success) {
            return respData.data
          } else {

            // ✅ OR condition for multiple error formats
            const errorMsg =
              respData.errorMessage ||
              respData.error_message ||
              respData.message ||
              respData.errors?.[0]?.message ||
              "Something Went Wrong..."

            toast(t => (
              <ToastMessage t={t} message={errorMsg} status={"danger"} />
            ))

            return ''
          }
        }
      })
      .catch((error) => {
        const errorresponse = error.response

        if (errorresponse) {
          const status = errorresponse.status

          if (status === 403) {
            return ''

          } else if (status === 406) {
            toast(t => (
              <ToastMessage t={t} message={"Unauthorized"} status={"danger"} />
            ))
            return ''

          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (
                <ToastMessage t={t} message={"Session expired"} status={"danger"} />
              ))
              return ''
            }

          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()

          } else {

            const backendErrorMsg =
              errorresponse.data?.errorMessage ||
              errorresponse.data?.error_message ||
              errorresponse.data?.message ||
              "Something Went Wrong..."

            toast(t => (
              <ToastMessage t={t} message={backendErrorMsg} status={"danger"} />
            ))

            return ''
          }
        }
      })
  } else if (method === 'patch') {
    return await authAxios.patch(endpoint, requestPayload)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  } else if (method === 'delete') {
    return await authAxios.delete(endpoint)
      .then((response) => {
        const respData = response.data
        if (respData) {
          if (respData.success) {
            const resData = respData.data
            return resData
          } else {
            if (respData.errorMessage) {
              toast(t => (<ToastMessage t={t} message={respData.errorMessage} status={"danger"} />))
            } else {
              toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            }
            return ''
          }
        }
      }).catch((error) => {
        const errorresponse = error.response
        if (errorresponse) {
          const status = errorresponse.status
          if (status === 403) {
            return ''
          } else if (status === 406) {
            toast(t => (<ToastMessage t={t} message={"unauthorized"} status={"danger"} />))
            return ''
          } else if (status === 419) {
            if (!getUserCall) {
              getUserCall = true
              toast(t => (<ToastMessage t={t} message={"cookie"} status={"danger"} />))
              return ''
            }
          } else if (status === 401) {
            localStorage.clear()
            window.location.reload()
          } else {
            toast(t => (<ToastMessage t={t} message={"Something Went Wrong..."} status={"danger"} />))
            return ''
          }
        }
      })
  }
}

export const GetUsers = createAsyncThunk("appCommonReducers/GetUsers", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUsers}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const allUsers = []
    resultData.forEach((element) => {
      const userId = element.id ?? element.userId ?? element.user_id
      const name = element.fullName ?? element.name ?? element.displayName ?? ''
      const givenName = element.givenName ?? element.given_name ?? ''
      const surname = element.surname ?? element.surName ?? element.lastName ?? element.last_name ?? ''
      const email = element.email ?? element.mail ?? element.userEmail ?? ''
      const companyId = element.companyId ?? element.company_id ?? null
      const isActive = element.isActive ?? element.is_active ?? false
      allUsers.push({ userId, name, givenName, surname, email, companyId, status: isActive ? 'Active' : 'InActive' })
    })
    return {
      data: allUsers,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllUsers = createAsyncThunk("appCommonReducers/GetAllUsers", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllUsers}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    const allUsers = []
    resultData.forEach((element) => {
      const userId = element.id ?? element.userId ?? element.user_id
      const givenName = element.givenName ?? element.given_name ?? ''
      const surname = element.surname ?? element.surName ?? element.lastName ?? element.last_name ?? ''
      const derivedName = `${givenName} ${surname}`.trim()
      const name = element.fullName ?? element.name ?? element.displayName ?? derivedName
      const email = element.email ?? element.mail ?? element.userEmail ?? ''
      const companyId = element.companyId ?? element.company_id ?? null
      const isActive = element.isActive ?? element.is_active ?? false
      allUsers.push({ userId, name, givenName, surname, email, companyId, status: isActive ? 'Active' : 'InActive' })
    })
    return {
      data: allUsers,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetAllRoles = createAsyncThunk("appCommonReducers/GetAllRoles", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllRoles}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)
  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetUserRoles = createAsyncThunk("appCommonReducers/GetUserRoles", async (uid) => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetUserRoles}?userId=${uid}`
  const data = ''
  const resultData = await apiCall(method, endpoint, data)


  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const SaveUserRoles = createAsyncThunk("appCommonReducers/SaveUserRoles", async (rdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.SaveUserRoles}?userId=${rdata.userId}`
  const data = rdata.data
  const resultData = await apiCall(method, endpoint, data)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const CreateUser = createAsyncThunk("appCommonReducers/CreateUser", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.CreateUser}`
  const data = {
    Email: payload.email,
    Is_Active: true
  }
  const resultData = await apiCall(method, endpoint, data)

  return {
    data: resultData || null,
    success: Boolean(resultData)
  }
})

export const UpdateUser = createAsyncThunk("appCommonReducers/UpdateUser", async (payload) => {
  const method = 'patch'
  const endpoint = `${ApiUrls.UpdateUser}?userId=${payload.userId}`
  const data = {}
  if (Object.prototype.hasOwnProperty.call(payload, 'email')) {
    data.email = payload.email
  }
  if (Object.prototype.hasOwnProperty.call(payload, 'isActive')) {
    data.is_active = payload.isActive
  }
  const resultData = await apiCall(method, endpoint, data)

  return {
    data: resultData || null,
    success: Boolean(resultData)
  }
})

export const CreateRoleUser = createAsyncThunk("appCommonReducers/CreateRoleUser", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.RoleCreateUser}`
  const data = {
    firstName: payload.firstName || '',
    lastName: payload.lastName || '',
    email: payload.email,
    UserRoles: []
  }
  const resultData = await apiCall(method, endpoint, data)

  return {
    data: resultData || null,
    success: Boolean(resultData)
  }
})

export const UpdateRoleUser = createAsyncThunk("appCommonReducers/UpdateRoleUser", async (payload) => {
  const method = 'patch'
  const endpoint = `${ApiUrls.RoleUpdateUser}`
  const data = {
    id: payload.id,
    isActive: payload.isActive,
    modifiedBy: payload.modifiedBy
  }
  const resultData = await apiCall(method, endpoint, data)

  return {
    data: resultData || null,
    success: Boolean(resultData)
  }
})

export const GetSchemas = createAsyncThunk("appCommonReducers/GetSchemas", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetAllCollections}`
  const resultData = await apiCall(method, endpoint, '')
  const collections = Array.isArray(resultData) ? resultData : []

  return {
    collections,
    count: collections.length
  }
})

export const SaveUserCollectionMapping = createAsyncThunk("appCommonReducers/SaveUserCollectionMapping", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.UserCollectionMapping}`
  const data = {
    user_id: payload.userId,
    collection_ids: payload.collectionIds,
    is_active: true
  }
  const resultData = await apiCall(method, endpoint, data)

  return {
    data: resultData || null,
    success: Boolean(resultData)
  }
})

export const GetDPPReportByDate = createAsyncThunk("appCommonReducers/GetDPPReportByDate", async (payload) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetInspectionDashboardData}`
  const resultData = await apiCall(method, endpoint, payload)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCategories = createAsyncThunk("appCommonReducers/GetCategories", async () => {
  const method = 'get'
  const endpoint = `${ApiUrls.GetCategories}`
  const resultData = await apiCall(method, endpoint, '')

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetCategorieTypesDescription = createAsyncThunk("appCommonReducers/GetCategorieTypesDescription", async (wdata) => {
  const method = 'post'
  const endpoint = `${ApiUrls.GetCategorieTypesDescription}`
  const resultData = await apiCall(method, endpoint, wdata)

  if (resultData) {
    return {
      data: resultData,
      spinner: true,
      tokenExp: false
    }
  } else {
    return {
      data: [],
      spinner: true,
      tokenExp: false
    }
  }
})

export const GetIPAddress = createAsyncThunk("appCommonReducers/GetIPAddress", async () => {
  try {
    const response = await fetch('https://api.ipify.org?format=json')
    const data = await response.json()
    if (data.ip) {
      return {
        data: data.ip,
        spinner: true,
        tokenExp: false
      }
    }
  } catch (error) {
    // Fallback: try alternative API
    try {
      const response = await fetch('https://ipapi.co/json/')
      const data = await response.json()
      if (data.ip) {
        return {
          data: data.ip,
          spinner: true,
          tokenExp: false
        }
      }
    } catch (fallbackError) {
      // Silently fail
    }
  }
  return {
    data: '',
    spinner: true,
    tokenExp: false
  }
})

export const commonreducerSlice = createSlice({
  name: 'appCommonReducers',
  initialState: {
    usersData: null,
    allUsersData: [],
    uspiner: false,
    userRoleData: [],
    urspiner: false,

    vesselReportByDate: [],
    dppReportByDate: [],
    categories: [],
    allroles: [],

    chatSessions: [],
    chatSessionsSpinner: false,

    chatMessages: [],
    chatMessagesSpinner: false,

    ipAddress: '',
    ipAddressSpinner: false,

    userCollectionUsers: [],
    userCollectionUsersSpinner: false,
    collectionList: [],
    collectionListSpinner: false,
    selectedUserCollections: [],
    selectedUserCollectionsSpinner: false,

    documentsByCollection: [],
    documentsByCollectionSpinner: false,
    documentsByCollectionCount: 0,
    documentsByCollectionSchema: null,

    schemaList: [],
    schemaListSpinner: false,

    spinner1: false
  },
  reducers: {
    clearDocumentsByCollection: (state) => {
      state.documentsByCollection = []
      state.documentsByCollectionCount = 0
      state.documentsByCollectionSchema = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(displayMenu.fulfilled, (state, action) => {
        state.displayMenuBool = action.payload
      })
      // start role management
      .addCase(GetUsers.fulfilled, (state, action) => {
        if (action.payload) {
          state.uspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.usersData = action.payload.data
        }
      })
      .addCase(GetAllUsers.fulfilled, (state, action) => {
        if (action.payload) {
          state.tokenExp = action.payload.tokenExp
          state.allUsersData = action.payload.data
        }
      })
      .addCase(GetUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.userRoleData = action.payload.data
        }
      })
      .addCase(SaveUserRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
        }
      })
      .addCase(GetCategories.fulfilled, (state, action) => {
        if (action.payload) {
          state.spinner1 = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.categories = action.payload.data
        }
      })

      .addCase(GetDPPReportByDate.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.dppReportByDate = action.payload.data
        }
      })
      .addCase(GetAllRoles.fulfilled, (state, action) => {
        if (action.payload) {
          state.urspiner = action.payload.spinner
          state.tokenExp = action.payload.tokenExp
          state.allroles = action.payload.data
        }
      })

      .addCase(GetIPAddress.pending, (state) => {
        state.ipAddressSpinner = true
      })
      .addCase(GetIPAddress.fulfilled, (state, action) => {
        if (action.payload) {
          state.ipAddressSpinner = false
          state.ipAddress = action.payload.data
        }
      })
      .addCase(GetIPAddress.rejected, (state) => {
        state.ipAddressSpinner = false
        state.ipAddress = ''
      })
      .addCase(GetSchemas.pending, (state) => {
        state.schemaListSpinner = true
      })
      .addCase(GetSchemas.fulfilled, (state, action) => {
        state.schemaListSpinner = false
        state.schemaList = action.payload?.collections || []
      })
      .addCase(GetSchemas.rejected, (state) => {
        state.schemaListSpinner = false
        state.schemaList = []
      })

  }
})
export const { handleAddtoCart, clearDocumentsByCollection } = commonreducerSlice.actions
export default commonreducerSlice.reducer
